import type { CommunityDetail } from '@pba/react-network';
import { ContentWrapper } from 'ui';
import { CommunityJoinButtons } from './community-join-buttons';
import { Description } from './description';

export type P = {
  community: CommunityDetail;
};

const CommunityAbout = ({ community }: P) => (
  <ContentWrapper>
    {/* TODO: Will be used in Task #87927 for Community about details card */}
    {/* TODO: Will be used in Task #87927 for Community about administrators card */}
    <CommunityJoinButtons community={community} />
    <Description community={community} />
    {/* TODO: Will be used in Task #87927 for Community about invite */}
  </ContentWrapper>
);

export default CommunityAbout;
